import { Injectable } from '@angular/core';
import { CurrenciesResourceService, ICurrencyRate } from './currencies-resource.service';
import { Observable, throwError } from 'rxjs';
import { shareReplay, catchError } from 'rxjs/operators';

@Injectable()
export class CachedCurrenciesService {
    private readonly cache: Map<string, Observable<ICurrencyRate[]>> = new Map();

    constructor(
        private readonly currenciesResourceService: CurrenciesResourceService
    ) { }

    public searchCurrenciesRates(currencyCode: string, targetCurrencyCode: string): Observable<ICurrencyRate[]> {
        const key: string = `${currencyCode}-${targetCurrencyCode}`;

        if (!this.cache.has(key)) {
            const response: Observable<ICurrencyRate[]> = this.currenciesResourceService
                .searchCurrenciesRates(currencyCode, targetCurrencyCode)
                .pipe(
                    shareReplay(1),
                    catchError((error: Error) => {
                        this.cache.delete(key);
                        return throwError(error);
                    }),
                );

            this.cache.set(key, response);

            return response;
        }

        return this.cache.get(key);
    }
}